import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import useMainBankAccountId from 'common/hooks/useMainBankAccountId';

const useCurrentBankAccountId = ({
  shouldFallbackToMainBankAccount = false,
} = {}) => {
  const history = useHistory();

  const { search } = useLocation();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const currentBankAccountId = searchParams.get('bankAccountId');

  const { loading: loadingMainBankAccountId, mainBankAccountId } =
    useMainBankAccountId({
      skip: Boolean(currentBankAccountId),
    });

  const fallback = shouldFallbackToMainBankAccount
    ? mainBankAccountId
    : undefined;

  const setCurrentBankAccountId = useCallback(
    (nextBankAccountId: string | undefined) => {
      history.replace({
        search: nextBankAccountId ? `?bankAccountId=${nextBankAccountId}` : '',
      });
    },
    [history],
  );

  return {
    currentBankAccountId: currentBankAccountId || fallback,
    loadingCurrentBankAccountId: loadingMainBankAccountId,
    mainBankAccountId,
    setCurrentBankAccountId,
  };
};

export default useCurrentBankAccountId;
